import { Database } from '../Database';
const DB = Database;

export interface Get_Content {
	getContent(): Promise<string>
}

export class Dad_Joke implements Get_Content {
	async getContent() {
		const response = await fetch('https://icanhazdadjoke.com/', {
			headers: {
				Accept: 'application/json'
			}
		});
		const data = await response.json();
		return data.joke;
	}
}

export class Stoicism_Quote implements Get_Content {
	async getContent() {
		const response = await fetch('https://api.stoicism.io/quotes/random', {
			headers: {
				Accept: 'application/json'
			}
		})
		const json = await response.json();
		return json.data;
	}
}

export class Comedian_Joke implements Get_Content {
	async getContent() {
		return await DB.getRandomJoke();
	}
}